import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import './SortableItem.css';

export function SortableItem({ id, children }: { id: string; children: React.ReactNode }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      className={`sortable-item ${isDragging ? 'sortable-item--dragging' : 'sortable-item--not-dragging'}`}
      {...attributes} 
      {...listeners}
    >
      {children}
    </div>
  );
}
